
/** @format */

import React, { useEffect } from 'react';
import { Grid, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { InputV2, DatePickerPod, GuildsSelect, ProductsSelect, DealersSelect, Icons, InputCurrency } from 'components';
import { useStyles } from './style';
import { DatePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const Constraints = ({
  consumeType,
  setConsumeType,
  voucherType,
  selectedProducts,
  setSelectedProducts,
  selectedDealers,
  setSelectedDealers,
}) => {


  // --HOOKS--//
  const methods = useFormContext();
  const classes = useStyles();

  useEffect(() => {
    methods.register('effectiveDates');
    methods.register('expireDate');
    return () => {
      methods.unregister('effectiveDates');
      methods.unregister('expireDate');
    };
  }, [methods.register, methods.unregister]);

  useEffect(() => {
    methods.register('guildCode');
    return () => {
      methods.unregister('guildCode');
    };
  }, [methods.register, methods.unregister]);

  // -- API REQUESTS --//

  // -- OTHER FUNCTIONS --//

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      item
      xs={12}
      md={9}
      lg={6}
      className={classes.root}
    >
      <GuildsSelect
        methods={methods}
        singleSelect
        name="guildCode"
        showBusinessGuilds={false}
        label="محدودیت روی محل مصرف"
        rules={['required']}
        tooltip="در این فیلد می‌توانید حساب تفصیلی کسب‌وکاری که کد تخفیف روی آن قابلیت استفاده دارد، را تعریف کنید."
      />
      <Grid item xs={12} md={6}>
        <DatePickerPod label="تاریخ شروع" showAsterisk>
          <DatePicker
            variant="inline"
            name="startDate"
            autoOk
            inputVariant="outlined"
            showTodayButton
            todayLabel="امروز"
            okLabel="تایید"
            cancelLabel="لغو"
            clearLabel="پاک کردن"
            labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
            value={methods.watch('effectiveDates')}
            onChange={(e) => {
              methods.setValue('effectiveDates', e);
            }}
            minDate={jMoment(new Date())}
            maxDate={methods.watch('expireDate') ?? null}
          />
        </DatePickerPod>
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePickerPod label="تاریخ انقضا" showAsterisk>
          <DatePicker
            variant="inline"
            name="startDate2"
            autoOk
            inputVariant="outlined"
            showTodayButton
            todayLabel="امروز"
            okLabel="تایید"
            cancelLabel="لغو"
            clearLabel="پاک کردن"
            labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
            value={methods.watch('expireDate')}
            onChange={(e) => methods.setValue('expireDate', e)}
            minDate={methods.watch('effectiveDates') ?? null}
          />
        </DatePickerPod>
      </Grid>
      <ProductsSelect
        methods={methods}
        name="serviceUsage"
        label="محصولات یا سرویس‌ها"
        tooltip="بن تخفیف جاری فقط بر روی محصولات یا سرویس‌های انتخاب شده در این لیست قابل اعمال خواهد بود. در صورت خالی گذاشتن این قسمت، قابل استفاده بر روی همه محصولات می‌باشد."
        selected={selectedProducts}
        setSelected={setSelectedProducts}
      />
      {/* TODO: PROD COMMENT */}
      <DealersSelect
        methods={methods}
        name="dealerBusinessId"
        label="محدودیت استفاده توسط کارگزاران"
        tooltip="در صورتی که کسب‌و‌کار فروشندگانی دارد که می‌خواهد آنها نیز بتوانند بن تخفیف را در فاکتورهای فروش خود اعمال نمایند، لازم است شناسه‌ی آن‌ها را در این بن‌ها ثبت نماید. در صورتی که مصرف بن به یک یا چند محصول محدود شود، لازم است مجوز فروش محصول نیز به فروشندگان داده شود."
        selected={selectedDealers}
        setSelected={setSelectedDealers}
      />
      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="حداقل تعداد اقلام یک فاکتور"
          errors={methods.formState.errors}
          name="minInvoiceItemCount"
          register={methods.register}
          rules={['isMin|0']}
          control={methods.control}
          currency
          allowDecimalPadding={false}
          minimumValue={0}
          decimalPlaces={0}
          currencyText="عدد"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputCurrency
          label="حداقل مبلغ یک فاکتور"
          fullWidth
          errors={methods.formState.errors}
          name="minInvoiceAmount"
          register={methods.register}
          rules={['isMin|0']}
          control={methods.control}
          minimumValue={0}
        />
      </Grid>
      {/* TODO: PROD COMMENT */}
      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="دفعات مجاز استفاده برای هر کاربر"
          errors={methods.formState.errors}
          name="perUserUsageLimitCount"
          register={methods.register}
          rules={['isMin|0']}
          control={methods.control}
          currency
          allowDecimalPadding={false}
          minimumValue={0}
          decimalPlaces={0}
          currencyText="دفعه"
          tooltip="در صورتی که بن تخفیف درصدی و به شکل نامحدود باشد، محدودیت دفعات مجاز استفاده برای هر کاربر اعمال خواهد شد و قابلیت استفاده نا محدود وجود نخواهد داشت."
        />
      </Grid>
      <Grid container xs={12}>
        <Grid item>
          <span className={classes.hintIcon}>
            <Icons icon='Info' color='#667585' hover='#667585' size='20' />
          </span>
        </Grid>
        <Grid item>
          <Typography className={classes.hintTxt}>
            در صورتی که مقدار دفعات مجاز استفاده کاربر را خالی بگذارید، مقدار آن برابر نامحدود قرار
            خواهد گرفت.
          </Typography>
        </Grid>
      </Grid>

      {voucherType === 'percentage' ? (
        <>
          <Grid item xs={12}>
            <Typography className={classes.typeTitle}>نوع محدودیت مصرف</Typography>
          </Grid>
          <RadioGroup
            row
            xs={12}
            required
            name="tp"
            onChange={(e) => {
              setConsumeType(e?.target?.value);
            }}
            value={consumeType}
            className={classes.options}
            defaultValue={consumeType}
          >
            <Grid item xs={12}>
              <FormControlLabel
                value="DISPOSABLE_ITEM"
                className={classes.radioItem}
                control={<Radio className={classes.radio} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                label={
                  <Typography className={classes.radioText}>
                    یک بار اعمال روی یک قلم کالا/محصول (از یک فاکتور)
                  </Typography>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                value="DISPOSABLE_INVOICE"
                className={classes.radioItem}
                control={<Radio className={classes.radio} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                label={
                  <Typography className={classes.radioText}>
                    یک بار اعمال روی تمام اقلام/محصولات (از یک فاکتور)
                  </Typography>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                value="UNLIMITED"
                className={classes.radioItem}
                control={<Radio className={classes.radio} icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                label={<Typography className={classes.radioText}>بدون محدودیت مصرف</Typography>}
              />
            </Grid>
          </RadioGroup>
        </>
      ) : null}
    </Grid>
  );
};



export default Constraints;
